'use es6';

import { emptyAuthData } from '../../utils/authUtils';
export default function Auth(state = emptyAuthData, action) {
  switch (action.type) {
    default:
      {
        return state;
      }
  }
}